import { useAuth } from '@AuthProvider';
import { Navigate } from 'react-router';
import { LayoutContextProvider } from 'src/contexts/LayoutContext';
import { NotificationProvider } from 'src/contexts/NotificationContext';
import { SocialContextProvider } from 'src/contexts/SocialContext';
import paths from 'src/router/paths';

interface SpartacusAppGuardProps {
  children: React.ReactNode;
}

export function SpartacusAppGuard({ children }: SpartacusAppGuardProps) {
  const { user, isLoading, jooiceFlow } = useAuth();

  if (isLoading) return null;
  if (
    !(
      user?.Account?.JooiceFlow === 'REVIEW' ||
      user?.Account?.JooiceFlow === 'SOCIAL' ||
      jooiceFlow === 'REVIEW' ||
      jooiceFlow === 'SOCIAL'
    )
  ) {
    return <Navigate to={paths.spartacusOnboarding} replace />;
  }

  return (
    <NotificationProvider>
      <SocialContextProvider>
        <LayoutContextProvider>{children}</LayoutContextProvider>
      </SocialContextProvider>
    </NotificationProvider>
  );
}
